import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames from 'classnames/bind';

import style from './style.scss';
import AccordionSection from "../AccordionSection";
import Button from "../Button";

class DelegatesList extends React.Component {

    _getListClassName() {

        var cx = classNames.bind(style);

        return cx({
            'list': true,
            'list--small': this.props.small
        });
    }

    _getDelegateActionsComponent(delegate, delegateIndex) {

        if (this.props.editable) {

            return (
                <div styleName="delegate-actions">
                    <Button
                        onClick={ this.props.editDelegate.bind(this, delegate) }
                        className={style['delegate-action']}
                    >
                        Edit
                    </Button>

                    <Button
                        onClick={ this.props.removeDelegate.bind(this, delegateIndex) }
                        className={style['delegate-action']}
                    >
                        Delete
                    </Button>
                </div>
            );
        }
    }

    render() {

        return (
            <ul className={ this._getListClassName() } id="delegate-list">

                {
                    this.props.delegates.map((delegate, index) => {

                        return (
                            <li key={ index }>
                                <AccordionSection>

                                    <span className={style['delegate-index']}>
                                        <strong>Delegate { index+1 }</strong>
                                    </span>

                                    <span styleName="delegate-name">
                                        { delegate.first_name } { delegate.last_name }
                                    </span>

                                    { this._getDelegateActionsComponent(delegate, index) }
                                </AccordionSection>
                            </li>
                        );
                    })
                }

            </ul>
        );
    }
}

export default CSSModules(DelegatesList, style);


// WEBPACK FOOTER //
// ./components/DelegateList/index.js